var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"agc-label",attrs:{"for":_vm.id}},[_vm._t("default"),(_vm.required)?_c('span',{staticClass:"agc-label__required"},[_vm._v("*")]):_vm._e(),_c('span',{staticClass:"agc-label__sub"},[_vm._v(" "),_vm._t("subLabel")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }